import type { RuntimeShim } from './types';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const HostReact: Record<string, unknown> = require('react');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const HostReactDOM: Record<string, unknown> = require('react-dom');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const HostJsxRuntime: Record<string, unknown> = require('react/jsx-runtime');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const HostJsxDevRuntime: Record<
  string,
  unknown
> = require('react/jsx-dev-runtime');

export const shareHostReact = (shim: RuntimeShim) => {
  shim.setSharedModules({
    'react/index': HostReact,
    'react/jsx-runtime': HostJsxRuntime,
    'react/jsx-dev-runtime': HostJsxDevRuntime,
    'react-dom/index': HostReactDOM,
  });
};
